/**
 * Currency Selector Component
 * Allows users to select their preferred currency
 */
import React, { useState, useEffect } from 'react';
import { useCurrency } from '../../context/CurrencyContext';
import { getCurrencies } from '../../services/currencyService';
import './CurrencySelector.css';

const CurrencySelector = ({ className = '', showLabel = true, onCurrencyChange }) => {
  const { currency, changeCurrency, loading: contextLoading } = useCurrency();
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadCurrencies();
  }, []);

  const loadCurrencies = async () => {
    try {
      setLoading(true);
      const data = await getCurrencies();
      setCurrencies(data.currencies || []);
      setError(null);
    } catch (err) {
      console.error('Failed to load currencies:', err);
      setError('Failed to load currencies');
      // Fallback to common currencies
      setCurrencies(['USD', 'SGD', 'EUR', 'GBP', 'JPY', 'AUD', 'HKD', 'CNY', 'AED', 'INR']);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = async (e) => {
    const newCurrency = e.target.value;
    const success = await changeCurrency(newCurrency);
    
    if (success) {
      // Call optional callback
      if (onCurrencyChange) {
        onCurrencyChange(newCurrency);
      }
      
      // Reload page to refresh all prices
      window.location.reload();
    }
  };

  if (loading) {
    return (
      <div className={`currency-selector ${className}`}>
        <select className="currency-select" disabled>
          <option>Loading...</option>
        </select>
      </div>
    );
  }

  return (
    <div className={`currency-selector ${className}`}>
      {showLabel && <label htmlFor="currency-select">Currency:</label>}
      <select
        id="currency-select"
        className="currency-select"
        value={currency}
        onChange={handleChange}
        disabled={contextLoading}
      >
        {currencies.map((curr) => (
          <option key={curr} value={curr}>
            {curr}
          </option>
        ))}
      </select>
      {error && <span className="currency-error">{error}</span>}
    </div>
  );
};

export default CurrencySelector;
